import { selectAnswer } from '../game.ts';
import type { GameState, PuzzleModel } from '../types.ts';
import type { NavigationDecision } from './navigation.ts';

export { DEFAULT_NAVIGATION_CONFIG, rankNextAnswers } from './navigation.ts';
export type {
	NavigationCandidate,
	NavigationConfig,
	NavigationContext,
	NavigationDecision,
	NavigationPart,
	NavigationPartLabel,
	NavigationReason,
} from './navigation.ts';

/**
 * Selects a decision's answer, with the cursor on its first empty cell (`selectAnswer`).
 * A `none` decision returns the same state. Unlike a tap, it keeps a smart-entry `echo`
 * (the rest of a whole word the player is still typing through the solved answer), so
 * those letters don't spill into the next answer.
 */
export function applyNavigation(model: PuzzleModel, state: GameState, decision: NavigationDecision): GameState {
	if (decision.selected === null) return state;
	const next = selectAnswer(model, state, decision.selected);
	return state.echo ? { ...next, echo: state.echo } : next;
}
